import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppState } from '@app/core/states/app.state';
import { RadioState } from '@app/core/states/radio.state';
import { exportSecMin, TimeSplited } from '@app/shared/utils';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Navigate } from '@ngxs/router-plugin';
import { Select, Store } from '@ngxs/store';
import { MobileSidenavService } from '@radioking/shared/common-services';
import {
  OpenSpecificPanel,
  PANELS_KEYS,
  TryActionUnlessPanelIsBlocking,
} from '@radioking/shared/pannel-manager';
import { Observable } from 'rxjs';

import { SchedulerCoreState } from '../../../../../scheduler-core/src/lib/states/scheduler-core.state';
import { Program } from '../../models/programs.model';
import { HideIntroExtro, StartEditProgram } from '../../states/programs.actions';
import { DeleteProgramModalComponent } from '../modals/delete-program-modal/delete-program-modal.component';
import { DuplicateProgramModalComponent } from '../modals/duplicate-program-modal/duplicate-program-modal.component';
import { ProgramAddPlaylistModalComponent } from '../modals/program-add-playlist-modal/program-add-playlist-modal.component';
import { EditProgramComponent } from '../sides/edit-program/edit-program.component';

@Component({
  selector: 'rk-program-details-header',
  templateUrl: './program-details-header.component.html',
  styleUrls: ['./program-details-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramDetailsHeaderComponent {
  @Select(SchedulerCoreState.hasPlaylists)
  hasPlaylists$: Observable<boolean>;

  @Input()
  program: Program;

  constructor(
    private readonly store: Store,
    private readonly dialog: MatDialog,
    private readonly mobileSidenavService: MobileSidenavService,
  ) {}

  @Dispatch()
  backToPrograms() {
    const radioId = this.store.selectSnapshot(RadioState.currentRadioId);

    return new Navigate(['radio', radioId, 'scheduler', 'programs']);
  }

  placeMatMenu() {
    const matMenu: HTMLElement = document.querySelector('.mat-mdc-menu-panel');
    matMenu.style['position'] = 'absolute';
    matMenu.style.left = '42px';
    matMenu.style.top = '-35px';
  }

  editProgram() {
    if (!this.store.selectSnapshot(AppState.onMobile)) {
      this.store.dispatch(
        new TryActionUnlessPanelIsBlocking(
          new OpenSpecificPanel(
            PANELS_KEYS.EDIT_PROGRAM,
            new StartEditProgram(this.program),
          ),
        ),
      );
    } else {
      this.store.dispatch(new StartEditProgram(this.program));
      this.mobileSidenavService.open(EditProgramComponent, {
        bgType: 'gray',
        closeAction: new HideIntroExtro(),
        noScroll: true,
        hasPadding: false,
      });
    }
  }

  duplicateProgram() {
    this.dialog.open(DuplicateProgramModalComponent, { data: this.program });
  }

  deleteProgram() {
    this.dialog.open(DeleteProgramModalComponent, { data: this.program });
  }

  getMinutesAndHours(value: number): TimeSplited {
    return exportSecMin(value);
  }

  addPlaylist() {
    this.dialog.open(ProgramAddPlaylistModalComponent, {
      data: { program: this.program },
    });
  }
}
